import { VideoProject } from "@/services/bedrock";

export function editorSubmitEvent(
  requiresQa?: boolean | null
): VideoProject.Event.SUBMIT_FOR_QA_REVIEW | VideoProject.Event.COMPLETE {
  return requiresQa ? VideoProject.Event.SUBMIT_FOR_QA_REVIEW : VideoProject.Event.COMPLETE;
}

export function isEditorResubmit(options: {
  qaStatus?: VideoProject["qaStatus"];
  revisionCount?: number | null;
}): boolean {
  return options.qaStatus === "REJECTED" || (options.revisionCount ?? 0) > 0;
}

export function editorSubmitActionLabel(requiresQa?: boolean | null, isResubmit = false): string {
  if (isResubmit) {
    return requiresQa ? "Resubmit for QA Review" : "Resubmit";
  }
  return requiresQa ? "Submit for QA Review" : "Submit";
}
